import React, {useState} from 'react';
import {Redirect} from 'react-router-dom';
import {db, useAuthState} from '../../../shared/services/firebase';
import {createUserWithEmailAndPassword, getAuth} from 'firebase/auth';
import {doc, setDoc} from 'firebase/firestore';
import Building from '@mui/icons-material/BusinessRounded';
import Database from '@mui/icons-material/StorageRounded';
import Envelope from '@mui/icons-material/EmailRounded';
import Geo from '@mui/icons-material/PlaceRounded';
import Key from '@mui/icons-material/VpnKeyRounded';
import Lock from '@mui/icons-material/LockRounded';
import Person from '@mui/icons-material/PersonRounded';

const Signup = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const [address, setAddress] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [error, setError] = useState();

  const authState = useAuthState();
  const auth = getAuth();

  const submit = (event) => {
    event.preventDefault();
    setLoading(true);
    createUserWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        await setDoc(doc(db, 'users', userCredential.user.uid), {
          email,
          name,
          surname,
          address,
          companyName,
          createdAt: new Date(),
        });
      })
      .catch((error) => {
        setError(error);
      });
    setLoading(false);
  };

  if (authState.user === undefined || loading) return <div className="loader" />;

  if (authState.user) return <Redirect to="/" />;

  return (
    <div className="Auth-form-container">
      <form className="Auth-form" onSubmit={submit}>
        <div className="Auth-form-content">
          <h1>Registrieren</h1>
          <p>Bitte geben Sie Ihre Informationen ein, um sich zu registrieren.</p>
          <h5><Key /> Zugangsdaten</h5>
          <hr />
          <div className="form-group mt-3">
            <p><Envelope /> E-Mail</p>
            <input
              type="email"
              className="form-control mt-1"
              placeholder="Geben Sie Ihre E-Mail-Adresse ein"
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="form-group mt-3">
            <p><Lock /> Passwort</p>
            <input
              type="password"
              className="form-control mt-1"
              placeholder="Geben Sie Ihr Passwort ein"
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          <h5 className="mt-4"><Database /> Persönlichen Informationen</h5>
          <hr />
          <div className="form-group mt-3">
            <p><Person /> Vorname und Nachname</p>
            <div className="d-flex">
              <input
                type="text"
                className="form-control mt-1 m-1"
                placeholder="Ihre Vorname"
                onChange={(event) => setName(event.target.value)}
              />
              <input
                type="text"
                className="form-control mt-1 m-1"
                placeholder="Ihre Nachname"
                onChange={(event) => setSurname(event.target.value)}
              />
            </div>
          </div>
          <div className="form-group mt-3">
            <div style={{justifyContent: 'space-between'}} className="d-flex">
              <p><Geo /> Adresse / Firmenadresse</p>
              <p>(Optional)</p>
            </div>
            <input
              type="text"
              className="form-control mt-1"
              placeholder="Geben Sie Ihre Adresse ein"
              onChange={(event) => setAddress(event.target.value)}
            />
          </div>
          <div className="form-group mt-3">
            <div style={{justifyContent: 'space-between'}} className="d-flex">
              <p><Building /> Firmenname</p>
              <p>(Optional)</p>
            </div>
            <input
              type="text"
              className="form-control mt-1"
              placeholder="Geben Sie Ihre Firmenname ein"
              onChange={(event) => setCompanyName(event.target.value)}
            />
          </div>
          <div className="text-center w-100">
            <div className="d-grid gap-2 mt-4 mb-5">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!name || !surname || !password || !email}
              >
                Registrieren
              </button>
            </div>
            {error && <p style={{color: 'red'}}><br />{error.code} {error.message}</p>}
            <p className="kein-konto">Bereits ein Konto haben? <br /> <a href="/">Anmelden</a></p>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Signup;
